import { SnackbarManager, Stack } from '@cmg/design-system';
import React, { useCallback } from 'react';

import { SidePanelTitle } from '../../components/side-bar/components/design-system';
import { useCmgEntityKeyContext } from '../../contexts/CmgEntityKeyContext';
import { useOfferingSidePanelOfferingId } from '../../hooks/useOfferingSidePanelMatch';
import ComplianceCertificates from './certificates/ComplianceCertificates';
import { ComplianceContextProvider } from './context/ComplianceContext';
import ComplianceProspectus from './prospectus/ComplianceProspectus';
import { useResendProspectusMutation } from './prospectus/hooks/useResendProspectusMutation';

const ComplianceRoute: React.FC = () => {
  const offeringId = useOfferingSidePanelOfferingId();
  const { cmgEntityKey } = useCmgEntityKeyContext();

  const [resendProspectus, { loading: isResending }] = useResendProspectusMutation({ offeringId });

  const handleResendProspectus = useCallback(async () => {
    try {
      const { validationError } = await resendProspectus({
        investorKeys: [cmgEntityKey!],
      });

      if (validationError) {
        SnackbarManager.error(validationError);
      } else {
        SnackbarManager.success('Documentation was sent successfully.');
      }
    } catch {
      SnackbarManager.error('Documentation was not sent. Required data missing.');
    }
  }, [cmgEntityKey, resendProspectus]);

  return (
    <Stack>
      <SidePanelTitle>Compliance</SidePanelTitle>
      <ComplianceContextProvider offeringId={offeringId} cmgEntityKey={cmgEntityKey}>
        <Stack gap={2}>
          <Stack data-testid="compliance-certificates-wrapper">
            <ComplianceCertificates offeringId={offeringId} cmgEntityKey={cmgEntityKey} />
          </Stack>
          <Stack data-testid="compliance-prospectus-wrapper">
            <ComplianceProspectus
              offeringId={offeringId}
              cmgEntityKey={cmgEntityKey!}
              onResendProspectus={handleResendProspectus}
              isResending={isResending}
            />
          </Stack>
        </Stack>
      </ComplianceContextProvider>
    </Stack>
  );
};

export default ComplianceRoute;
